
import { defaultOptions, options as optionsDefinition } from 'app/options';
import { connect } from 'react-redux';
import { compose, lifecycle } from 'recompose';
import { isEqual } from 'app/functions/general';
import {
    loadUi,
    setArrivalLocation,
    setDepartureDate,
    setDepartureLocation,
    setProductQuantity,
    setReturnDate,
    showReturnDate,
    updateOptions,
} from 'app/store/actions';
import { optionsSelector } from 'app/store/selectors';

const DumbWithData = ({ children }) => children;

const withLifecycle = lifecycle({
    async fetchData(props) {
        const { dispatch, options } = props;

        const currentOptions = this.oldOptions || {};
        const newOptions = { ...defaultOptions, ...currentOptions, ...options };

        // define initial search mask values
        if (!this.setInitialSearchMaskValues) {
            const searchMaskValues = newOptions.initialSearchMaskValues;

            if (searchMaskValues.departureCity) {
                dispatch(setDepartureLocation(searchMaskValues.departureCity));
            }

            if (searchMaskValues.arrivalCity) {
                dispatch(setArrivalLocation(searchMaskValues.arrivalCity));
            }

            if (searchMaskValues.departureDate) {
                dispatch(setDepartureDate(searchMaskValues.departureDate));
            }

            if (searchMaskValues.returnDate) {
                dispatch(showReturnDate());
                dispatch(setReturnDate(searchMaskValues.returnDate));
            }

            Object.keys(searchMaskValues.products).forEach((productType) => {
                dispatch(setProductQuantity(
                    productType,
                    searchMaskValues.products[productType],
                ));
            });

            this.setInitialSearchMaskValues = true;
        }

        if (!Object.keys(currentOptions).length || !isEqual(newOptions, currentOptions)) {
            this.oldOptions = newOptions;

            dispatch(updateOptions(newOptions));
        }

        dispatch(loadUi());
    },

    componentDidMount() {
        this.fetchData(this.props);
    },
});

const mapStateToProps = state => ({
    options: optionsSelector(state),
});

export const WithData = compose(
    connect(mapStateToProps),
    withLifecycle,
)(DumbWithData);

WithData.propTypes = optionsDefinition;
WithData.defaultProps = defaultOptions;
